module.exports = __webpack_public_path__ + "img/ewm.37ed048d.png";